import React from 'react'
import './continueenabled.css'
import { Button } from 'react-bootstrap'

function ContinueEnabled({onContinue, disabled}) {
  return (
    <div className='btn-wrapper'>
        <button
            className='continue-btn'
            onClick={onContinue}
            disabled={disabled}
            style={disabled ? { opacity: 0.6, cursor: 'not-allowed' } : {}}
        >
            {disabled ? 'Please wait...' : 'Continue'}
        </button>
    </div>
  )
}

export default ContinueEnabled